export const checkPasswordForValidity = {
	getMessage(field) {
		return field + " muss mindestens eine Zahl, einen Groß- und einen Kleinbuchstaben enthalten und mindestens 8 Zeichen lang sein.";
	},
	validate(value) {
		if(value) {
			return new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})").test(value);
		} else {
			return true;
		}
	},
};


// WEBPACK FOOTER //
// ./src/validator/checkPasswordForValidity.js